import { Effect, takeEvery } from 'redux-saga/effects';

import { ActionTypes } from '../constants';
import { loadLayoutDetailsMetadata } from './loadLayoutDetailsMetadata';
import { updateReusableLayoutTags } from './updateReusableLayoutTags';

const effects: Effect[] = [
  takeEvery(ActionTypes.LOAD_LAYOUT_DETAILS_METADATA, loadLayoutDetailsMetadata),
  takeEvery(ActionTypes.UPDATE_REUSABLE_LAYOUT_TAGS, updateReusableLayoutTags),
];

export default effects;
